import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroBanner from './components/HeroBanner';
import FeaturedGames from './components/FeaturedGames';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import FAQ from './components/FAQ';
import HotArticles from './components/HotArticles';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Galgame资源网站PC',
  url: 'https://galgame-pc.com',
  description: '最全PC版Galgame下载平台，汇聚海量汉化版、日文原版Galgame游戏资源，涵盖补丁包及攻略合集，支持Windows系统免费下载。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://galgame-pc.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Galgame资源网站PC',
  url: 'https://galgame-pc.com',
  description: '最全PC版Galgame下载平台',
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="Galgame资源网站PC — 最全PC版Galgame下载平台"
        description="寻找galgame资源网站pc？本站汇聚海量PC端Galgame游戏资源，涵盖汉化版、日文原版、补丁包及攻略，支持Windows系统免费下载，更新及时、分类清晰，是PC玩家必收藏的Galgame资源网站。"
        keywords="galgame资源网站 pc,PC版galgame下载,galgame汉化资源,galgame免费下载网站,Windows galgame游戏,galgame补丁下载,galgame攻略合集"
        canonicalPath="/"
        jsonLd={[homeJsonLd, orgJsonLd]}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <FeaturedGames />
        <CategoryGrid />
        <LatestUpdates />
        <FAQ />
        <HotArticles />
      </main>
      <Footer />
    </>
  );
}